export const HANDLE_REGEX = /^[0-9a-z_.]*$/;
export const HANDLE_MIN_LENGTH = 5;
export const HANDLE_MAX_LENGTH = 25;
